// Material Dashboard 2 PRO React base styles
import borders from "assets/theme/base/borders";

const { borderRadius } = borders;

const menu = {
  defaultProps: {
    disableAutoFocusItem: true,
  },

  styleOverrides: {
    paper: {
      backgroundColor: "#ffffff !important",
      backgroundImage: "none !important",
      borderRadius: borderRadius.md,
      border: "1px solid rgba(0, 0, 0, 0.12)",
    },
    root: {
      "& .MuiPaper-root": {
        backgroundColor: "#ffffff !important",
        backgroundImage: "none !important",
      },
    },
  },
};

export default menu;
